import { defineStore } from "pinia";

export const useSagePaySlipStore = defineStore('sagePaySlip', {
    state: () => ({
        sagePaySlip: {},
        sagePaySlips: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setSagePaySlip(sagePaySlip) {
            this.sagePaySlip = sagePaySlip
        },
        setSagePaySlips(sagePaySlips) {
            this.sagePaySlips = sagePaySlips
        },
        addSagePaySlip(sagePaySlip) {
            this.sagePaySlips.unshift(sagePaySlip)
        },
        updateSagePaySlip(sagePaySlip) {
            let index = this.sagePaySlips.findIndex(cl => cl.id === sagePaySlip.id)
            this.sagePaySlips.splice(index, 1, sagePaySlip)
        },
        deleteSagePaySlip(sagePaySlip) {
            let index = this.sagePaySlips.findIndex(cl => cl.id === sagePaySlip.id)
            this.sagePaySlips.splice(index, 1)
        },
    },
});